import React from 'react';
import './PullToRefresh.css';

/**
 * Pull to Refresh Indicator Component
 * Displays visual feedback during pull-to-refresh gesture
 */
function PullToRefresh({ pullDistance, isRefreshing, progress, threshold = 80 }) {
  // Don't render if not pulling and not refreshing
  if (pullDistance === 0 && !isRefreshing) {
    return null;
  }

  const isTriggered = progress >= 1 || isRefreshing;
  const rotation = progress * 180;
  const scale = Math.min(0.5 + (progress * 0.5), 1);
  
  return (
    <div 
      className={`pull-to-refresh-container ${isRefreshing ? 'refreshing' : ''}`}
      style={{ 
        height: `${pullDistance}px`,
        opacity: Math.min(progress * 1.5, 1)
      }}
    >
      <div 
        className={`pull-to-refresh-indicator ${isTriggered ? 'triggered' : ''}`}
        style={{ 
          transform: `scale(${scale}) rotate(${rotation}deg)`,
        }}
      >
        {isRefreshing ? (
          <div className="refresh-spinner">
            <svg viewBox="0 0 24 24" className="spinner-svg">
              <circle
                cx="12"
                cy="12"
                r="10"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeDasharray="60"
                strokeDashoffset="0"
              />
            </svg>
          </div>
        ) : (
          <div className="pull-arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="7,10 12,15 17,10" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
        )}
      </div>
      <span className="pull-to-refresh-text">
        {isRefreshing 
          ? 'Refreshing...' 
          : isTriggered 
            ? 'Release to refresh' 
            : 'Pull to refresh'}
      </span>
    </div>
  );
}

export default PullToRefresh;
